import type { IconProps } from './types';

export const CheckListIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M19.7144 17.6783C20.1285 17.6784 20.4643 18.0143 20.4644 18.4283C20.4644 18.8425 20.1286 19.1782 19.7144 19.1783H13.2857C12.8715 19.1783 12.5357 18.8425 12.5357 18.4283C12.5359 18.0142 12.8716 17.6783 13.2857 17.6783H19.7144ZM5.03571 18.9644H9.32184V14.6783H5.03571V18.9644ZM19.7144 13.3931L19.7906 13.397C20.1689 13.4353 20.4644 13.7547 20.4644 14.1431C20.4643 14.5315 20.1689 14.851 19.7906 14.8892L19.7144 14.8931H13.2857C12.8715 14.8931 12.5358 14.5573 12.5357 14.1431C12.5357 13.7289 12.8715 13.3931 13.2857 13.3931H19.7144ZM19.7144 9.107C20.1286 9.10708 20.4644 9.44285 20.4644 9.857C20.4644 10.2712 20.1286 10.6069 19.7144 10.607H13.2857C12.8715 10.607 12.5357 10.2712 12.5357 9.857C12.5357 9.4428 12.8715 9.107 13.2857 9.107H19.7144ZM5.03571 9.32185H9.32184V5.03571H5.03571V9.32185ZM19.7144 4.82185C20.1286 4.82192 20.4644 5.15768 20.4644 5.57185C20.4642 5.98582 20.1284 6.32177 19.7144 6.32185H13.2857C12.8716 6.32185 12.5359 5.98587 12.5357 5.57185C12.5357 5.15763 12.8715 4.82185 13.2857 4.82185H19.7144ZM10.8218 19.0718C10.8216 19.8408 10.1974 20.4644 9.42828 20.4644H4.92828C4.15926 20.4643 3.53593 19.8407 3.53571 19.0718V14.5718C3.53571 13.8027 4.15916 13.1784 4.92828 13.1783H9.42828C10.1975 13.1783 10.8218 13.8026 10.8218 14.5718V19.0718ZM10.8218 9.42829C10.8218 10.1975 10.1975 10.8218 9.42828 10.8218H4.92828C4.15916 10.8217 3.53571 10.1975 3.53571 9.42829V4.92829C3.53586 4.15926 4.15925 3.53586 4.92828 3.53571H9.42828C10.1974 3.53571 10.8217 4.15917 10.8218 4.92829V9.42829Z"
        fill={color}
      />
    </svg>
  );
};
